import { useEffect, useRef } from "react";


export const CookieContainer = () => {
    const cookieBotUrl = "https://consent.cookiebot.com/e1b279dc-4e7d-453e-a3b1-f922ab7c3fdd/cd.js";

    const scriptRoot = useRef<HTMLDivElement>(null)
    let script = document.querySelector(`script[src="${cookieBotUrl}"]`);
    if (!script) {
        script = document.createElement("script");
        script.setAttribute("type", "application/javascript");
        script.setAttribute("src", cookieBotUrl);
        script.setAttribute('async', 'async');
        script.setAttribute('defer', 'defer');
    }

    //the placeholder div is always rendered, so its ref is set by the time this runs
    useEffect(() => {
        scriptRoot.current!.append(script!);
    }, [])

    return (
        <div id="cookiebotScriptPlaceholder">
            <div className="embeddedScript" ref={scriptRoot} />
        </div>
    );
};
